import { createContext, useState, useRef, useCallback, useEffect } from "react";
import { getDateUser, getUUID, getPendingMe, checkMyAuthorizations } from "./peticionesApi";
import { tieneAsignacionesEmpleado } from "../pages/auditor/auditorChecklistApi";

export const NewContext = createContext([]);

const initialValuesAlert = {
  msj: "",
  tipe: "",
};

const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Error decodificando JWT:", e);
    return null;
  }
};

export const ContextProvider = ({ children }) => {
  const [flag, setFlag] = useState(window.innerWidth < 1080 ? false : true);
  const [getRol, setRol] = useState();
  const [getDisplayRol, setDisplayRol] = useState();
  const [getToken, setToken] = useState();
  const [getId, setId] = useState();
  const [getEmail, setEmail] = useState();
  const [getCompany, setCompany] = useState();
  const [valuesAlert, setValuesAlert] = useState(initialValuesAlert);
  const [flagAlert, setFlagAlert] = useState(false);
  const [presente, setPresente] = useState(null);
  const [contador, setContador] = useState(0);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [empleadoNameRegister, setEmpleadoNameRegister] = useState();
  const [month, setMonth] = useState(new Date().getMonth());
  const [profileImage, setProfileImage] = useState(null);
  const [getArea, setArea] = useState();
  const [getModules, setModules] = useState([]);
  const [pendingSummary, setPendingSummary] = useState(null);

  const refreshPendingSummary = useCallback(async () => {
    try {
      const pendingRes = await getPendingMe();
      setPendingSummary(pendingRes?.data ?? null);
    } catch (e) {
      console.error("Error al refrescar pendientes:", e);
    }
  }, []);

  // Escuchar eventos de actualización para refrescar pendingSummary
  useEffect(() => {
    const events = [
      "updatePendingCapacitaciones",
      "updatePendingRequests",
      "updatePendingRecibos",
      "updatePendingTickets",
      "confirmarFirma",
    ];
    events.forEach((evt) => window.addEventListener(evt, refreshPendingSummary));
    return () => {
      events.forEach((evt) => window.removeEventListener(evt, refreshPendingSummary));
    };
  }, [refreshPendingSummary]);

  const [isSessionReady, setIsSessionReady] = useState(false);
  const [isFleetAuthorized, setIsFleetAuthorized] = useState(false);
  const [fleetScope, setFleetScope] = useState(null);
  const [fleetAreaId, setFleetAreaId] = useState(null);
  const [hasAssignedVehicle, setHasAssignedVehicle] = useState(false);
  const [isArmamentAuthorized, setIsArmamentAuthorized] = useState(false);
  const [isUniformAuthorized, setIsUniformAuthorized] = useState(false);
  const [isMedLabAuthorized, setIsMedLabAuthorized] = useState(false);
  const [isHabAuthorized, setIsHabAuthorized] = useState(false);
  const [isHabViewOnly, setIsHabViewOnly] = useState(false);
  const [isCalidadAuthorized, setIsCalidadAuthorized] = useState(false);
  const [isDeliveryAuthorized, setIsDeliveryAuthorized] = useState(false);
  const [isCapAuthorized, setIsCapAuthorized] = useState(false);
  const [hasAuditorChecklist, setHasAuditorChecklist] = useState(false);
  const [capScope, setCapScope] = useState(null);
  const [capAreaId, setCapAreaId] = useState(null);
  const [isTecnicaAuthorized, setIsTecnicaAuthorized] = useState(false);
  // Alcance de la autorización de Técnica (FULL, AREA o null): decide quién cancela y elimina órdenes.
  const [tecnicaScope, setTecnicaScope] = useState(null);
  // Nivel de stock de Técnica (CONSULTA, PANOL, GESTION o null). «Cargado» separa «todavía no se sabe»
  // de «no tiene»: isSessionReady se prende antes de que vuelva /me. El aviso explica un null raro.
  const [tecnicaStockNivel, setTecnicaStockNivel] = useState(null);
  const [tecnicaStockCargado, setTecnicaStockCargado] = useState(false);
  const [tecnicaStockAviso, setTecnicaStockAviso] = useState(null);

  const isInitializing = useRef(false);

  const setStates = () => {
    setFlag(window.innerWidth < 1080 ? false : true);
    setRol(null);
    setDisplayRol(null);
    setToken(null);
    setId(null);
    setEmail(null);
    setCompany(null);
    setValuesAlert(initialValuesAlert);
    setFlagAlert(false);
    setPresente(0);
    setSelectedEmployee(null);
    setModules([]);
    setPendingSummary(null);
    setIsFleetAuthorized(false);
    setHasAssignedVehicle(false);
    setIsUniformAuthorized(false);
    setIsMedLabAuthorized(false);
    setIsDeliveryAuthorized(false);
    setIsCapAuthorized(false);
    setCapScope(null);
    setCapAreaId(null);
    setIsTecnicaAuthorized(false);
    setTecnicaScope(null);
    setTecnicaStockNivel(null);
    setTecnicaStockCargado(false);
    setTecnicaStockAviso(null);
    setHasAuditorChecklist(false);
    setIsSessionReady(false);
    isInitializing.current = false;
  };

  const getAlert = useCallback(({ msj, tipe = "succes" }) => {
    // ModalAlert y GlobalAlert sólo conocen "succes" (así, con una s) y muestran cualquier otro tipo como
    // «Advertencia»: "success" es la forma que usan Técnica y otros módulos, y un éxito no puede salir amarillo.
    setValuesAlert({ msj, tipe: tipe === "success" ? "succes" : tipe });
    setFlagAlert(true);
  }, []);

  // Escuchar errores 403 del interceptor de Axios y mostrar alerta global
  useEffect(() => {
    const handle403 = () => {
      getAlert({
        msj: "No tiene permisos para realizar esta acción. Contacte con su administrador.",
        tipe: "error"
      });
    };
    window.addEventListener('axios-forbidden', handle403);
    return () => window.removeEventListener('axios-forbidden', handle403);
  }, [getAlert]);

  const validateLoginToken = (token) => {
    const payload = decodeJWT(token);

    if (!payload) {
      return { type: "error", message: "Token inválido" };
    }

    if (payload.companies && Array.isArray(payload.companies) && payload.companies.length > 0) {
      return { type: "multi-company", companies: payload.companies };
    }

    return { type: "single-company", token, payload };
  };

  const controlToken = useCallback(async (tokenRequest) => {
    if (isInitializing.current) return;
    isInitializing.current = true;
    setIsSessionReady(false);
    // Sin esto, al reentrar con otro usuario el nivel del anterior valdría hasta que vuelva /me.
    setTecnicaStockCargado(false);

    try {
      const username = sessionStorage.getItem("username");

      if (!username) {
        throw new Error("No hay username en sessionStorage");
      }
      const { data: userData } = await getDateUser(username);

      const userRole = userData.appUserRoles?.[0] || null;
      const effectiveRole =
        userRole === 'ROLE_REFERENTE' ? 'ROLE_SUPERVISOR'
        : userRole === 'ROLE_SUPERVISOR_MAYOR' ? 'ROLE_JEFE_AREA'
        : userRole;

      let employeeData = null;

      if (userData.email) {
        try {
          const response = await getUUID(userData.email);
          employeeData = response.data;
        } catch (error) {
          console.error("Error al obtener UUID:", error);
        }
      }

      setToken(tokenRequest);
      setRol(effectiveRole);
      setDisplayRol(userRole);
      setEmail(userData.email);
      setCompany(userData.company);
      setModules(Array.isArray(userData.modules) ? userData.modules : []);

      if (employeeData) {
        setId(employeeData.id);
        setSelectedEmployee(employeeData);
        setArea(employeeData.area_id);
      }
      setIsSessionReady(true);

      // Fetch pendientes (recibos, capacitaciones) para alertar al usuario
      try {
        const pendingRes = await getPendingMe();
        setPendingSummary(pendingRes?.data ?? null);
      } catch (e) {
        console.error("Error al obtener pendientes:", e);
      }

      // Unified authorization check — single HTTP call instead of 7
      const mods = Array.isArray(userData.modules) ? userData.modules : [];
      if (effectiveRole === 'ROLE_ADMIN') {
        setIsFleetAuthorized(true);
        setFleetScope('FULL');
        setFleetAreaId(null);
        setIsArmamentAuthorized(true);
        setIsDeliveryAuthorized(true);
        setIsUniformAuthorized(true);
        setIsMedLabAuthorized(true);
        setIsHabAuthorized(true);
        setIsCalidadAuthorized(true);
        setIsCapAuthorized(true);
        setCapScope('FULL');
        setCapAreaId(null);
        setIsTecnicaAuthorized(true);
        setTecnicaScope('FULL');
        // El ADMIN gestiona el stock por su rol (el backend tampoco le pide permiso), si la empresa tiene Técnica.
        setTecnicaStockNivel(mods.includes('TECNICA') ? 'GESTION' : null);
        setTecnicaStockAviso(null);
        setTecnicaStockCargado(true);
      } else {
        try {
          const { data: auths } = await checkMyAuthorizations();

          if (mods.includes('FLOTAS') && auths.fleet?.authorized) {
            setIsFleetAuthorized(true);
            setFleetScope(auths.fleet.scope ?? null);
            setFleetAreaId(auths.fleet.area_id ?? null);
          } else {
            setIsFleetAuthorized(false);
            setFleetScope(null);
            setFleetAreaId(null);
          }
          setHasAssignedVehicle(auths.has_assigned_vehicle ?? false);

          setIsArmamentAuthorized(mods.includes('ARMAMENTOS') && (auths.armament?.authorized ?? false));
          setIsDeliveryAuthorized(mods.includes('ARMAMENTOS') && (auths.armament_delivery?.authorized ?? false));
          setIsUniformAuthorized(mods.includes('UNIFORMES') && (auths.uniforms?.authorized ?? false));
          setIsMedLabAuthorized(mods.includes('MEDICINA') && (auths.medicina_laboral?.authorized ?? false));
          setIsHabAuthorized(mods.includes('HABILITACIONES') && (auths.habilitaciones?.authorized ?? false));
          setIsHabViewOnly(auths.habilitaciones?.view_only ?? false);
          setIsCalidadAuthorized(auths.calidad?.authorized ?? false);

          setIsTecnicaAuthorized(mods.includes('TECNICA') && (auths.tecnica?.authorized ?? false));
          setTecnicaScope(mods.includes('TECNICA') && auths.tecnica?.authorized ? (auths.tecnica.scope ?? 'FULL') : null);
          // Es un nivel, no un booleano: las pantallas de stock preguntan con puede('PANOL').
          setTecnicaStockNivel(mods.includes('TECNICA') && auths.tecnica_stock?.authorized ? auths.tecnica_stock.scope : null);
          setTecnicaStockAviso(auths.tecnica_stock?.scope === 'LEGAJO_DUPLICADO' ? 'LEGAJO_DUPLICADO' : null);
          setTecnicaStockCargado(true);

          if (mods.includes('CAPACITACIONES') && auths.capacitaciones?.authorized) {
            setIsCapAuthorized(true);
            setCapScope(auths.capacitaciones.scope ?? null);
            setCapAreaId(auths.capacitaciones.area_id ?? null);
          } else {
            setIsCapAuthorized(false);
            setCapScope(null);
            setCapAreaId(null);
          }
        } catch (e) {
          console.error("Error al obtener autorizaciones:", e);
          setIsFleetAuthorized(false);
          setFleetScope(null);
          setFleetAreaId(null);
          setHasAssignedVehicle(false);
          setIsArmamentAuthorized(false);
          setIsDeliveryAuthorized(false);
          setIsUniformAuthorized(false);
          setIsMedLabAuthorized(false);
          setIsHabAuthorized(false);
          setIsCalidadAuthorized(false);
          setIsCapAuthorized(false);
          setCapScope(null);
          setCapAreaId(null);
          setIsTecnicaAuthorized(false);
          setTecnicaScope(null);
          // Sin /me no se sabe el nivel: la pantalla de stock lo dice en vez de mostrar «sin acceso».
          setTecnicaStockNivel(null);
          setTecnicaStockAviso('ERROR_ME');
          setTecnicaStockCargado(true);
        }
      }

      // Check if employee has auditor checklist assignments (non-blocking)
      try {
        const tiene = await tieneAsignacionesEmpleado();
        setHasAuditorChecklist(tiene);
      } catch {
        setHasAuditorChecklist(false);
      }

    } catch (error) {
      console.error("❌ Error en controlToken:", error);
      getAlert({ msj: "Ocurrió un error inesperado", tipe: "error" });
      setIsSessionReady(false);
      // Sin esto Técnica esperaba /me para siempre: con el aviso, su guardia dice que falló y ofrece recargar.
      setTecnicaStockAviso('ERROR_ME');
      setTecnicaStockCargado(true);
      isInitializing.current = false;
    }
  }, []);

  const values = {
    flag,
    setFlag,
    getToken,
    getRol,
    getDisplayRol,
    getId,
    getEmail,
    getCompany,
    controlToken,
    validateLoginToken,
    valuesAlert,
    setValuesAlert,
    getAlert,
    setFlagAlert,
    flagAlert,
    presente,
    setPresente,
    contador,
    setContador,
    selectedEmployee,
    setSelectedEmployee,
    setStates,
    month,
    setMonth,
    empleadoNameRegister,
    setEmpleadoNameRegister,
    profileImage,
    setProfileImage,
    getArea,
    setArea,
    getModules,
    setModules,
    pendingSummary,
    refreshPendingSummary,
    isSessionReady,
    isFleetAuthorized,
    fleetScope,
    fleetAreaId,
    hasAssignedVehicle,
    isArmamentAuthorized,
    isUniformAuthorized,
    isMedLabAuthorized,
    isHabAuthorized,
    isHabViewOnly,
    isCalidadAuthorized,
    isDeliveryAuthorized,
    isCapAuthorized,
    capScope,
    capAreaId,
    hasAuditorChecklist,
    isTecnicaAuthorized,
    tecnicaScope,
    tecnicaStockNivel,
    tecnicaStockCargado,
    tecnicaStockAviso,
  };

  return <NewContext.Provider value={values}>{children}</NewContext.Provider>;
};